const URL_TERMES_OF_USE = 'https://dash.bar/agb/'
const URL_PRIVACY_POLICY = 'https://dash.bar/datenschutz/'

export default { URL_TERMES_OF_USE, URL_PRIVACY_POLICY }
